import React, { Component } from 'react';
import _size from 'lodash/size';
import Modal from '../Modal';

class Banner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pincode: ''
    };
    this.bannerRef = React.createRef();
    const {
      images: { banner_store_desktop = '', banner_store_mobile = '' } = {}
    } = this.props.data;
    const imgUrl = innerWidth > 500 ? banner_store_desktop : banner_store_mobile;
    this.bannerStyle = {
      backgroundImage: `url(${imgUrl})`
    };
  }

  componentDidMount() {
    const { observer = {} } = this.props;
    observer.observe(this.bannerRef.current);
  }

  showStoreList = () => {
    const { pincode } = this.state;
    const { indexStatesProps: { showPincodeModal } = {} } = this.props;
    showPincodeModal(pincode);
  };

  onChange = e => {
    const { indexStatesProps: { showPincodeModal, hidePincodeModal } = {} } = this.props;

    this.setState({ [e.target.name]: e.target.value }, () => {
      const { pincode } = this.state;
      if (_size(pincode) === 6) {
        showPincodeModal(pincode);
      } else {
        hidePincodeModal();
      }
    });
  };

  render() {
    const {
      indexStatesProps: { hidePincodeModal, modal: { name, classes, content } = {} }
    } = this.props;

    const {
      images: { storeLogo = '' },
      altContent: { storeLogoAlt = '' },
      content: { bannerHeaderText = '', bannerSubheaderText = '', pincodePlaceholderText = '' }
    } = this.props.data;

    return (
      <div className="storePickup" id="banner" ref={this.bannerRef} style={this.bannerStyle}>
        <div className="heading-image">
          <img src={storeLogo} alt={storeLogoAlt} />
        </div>
        <div className="heading1 logo-header">{bannerHeaderText}</div>
        <div className="heading2">{bannerSubheaderText}</div>
        <div className="input">
          <input
            maxLength={6}
            minLength={6}
            name="pincode"
            value={this.state.pincode}
            onChange={e => this.onChange(e)}
            type="number"
            placeholder={pincodePlaceholderText}
          />
          <span className="ic-search" onClick={this.showStoreList} />
        </div>
        <Modal name={name} className={classes} onClose={hidePincodeModal}>
          {content}
        </Modal>
      </div>
    );
  }
}

export default Banner;
